import { makeAutoObservable } from "mobx"

import { catchErrors, chargeApi } from "@src/shared/api"
import { ChargeResponse, Payment } from "@src/shared/api/generated"

class PaymentsStore {
  charge?: ChargeResponse = {} as ChargeResponse
  isLoading = false
  loadCharge = async (id: string) => {
    this.isLoading = true

    chargeApi
      .getCharge(id)
      .then(({ data: result }) => {
        if (result.success) {
          this.charge = result.data

          this.payments =
            result.data?.payments?.map((item) => ({ key: item.id, ...item })) ||
            []
        }
      })
      .catch(catchErrors)
      .finally(() => {
        this.isLoading = false
      })
  }

  payments: Payment[] = []

  constructor() {
    makeAutoObservable(this)
  }

  get name() {
    return this.charge?.name
  }
}

export const paymentsStore = new PaymentsStore()
